<p-dialog modal="true" styleClass="atlas-dialog-m" position="center" [closable]="false" [(visible)]="showDialog">
  <ng-template pTemplate="header">
    {{ 'public-links.progress-dialog.upgrading-in-progress' | translate | titlecase }}
  </ng-template>
  <div class="mv-10 mb-20">
    {{ 'public-links.progress-dialog.message' | translate }}
  </div>
  <div class="mv-10 mct-flex mct-row mct-justify-end mct-items-center mct-gap-10"   >
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="close()">
      {{ 'public-links.progress-dialog.confirm' | translate | uppercase }}
    </button>
  </div>
</p-dialog>